import { ReactElement, useEffect, useState } from "react";
import { Select } from "antd";
import type { SelectProps } from "antd";

import "./backend-users.scss";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import TabsComponent from "../../components/tabs-component/tabs-component";
import KeyImage from "../../assets/key.svg";
import ShieldImage from "../../assets/shield-security.svg";
import { SearchOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import UsersList from "./components/users-list/users-list";
import CustomModal from "../../components/custom-modal/custom-modal";
import AddEditUser from "./components/add-edit-user/add-edit-user";
import RolesList from "./components/roles-list/roles-list";
import AddEditRole from "./components/add-edit-role/add-edit-role";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_BREADCRUMB } from "../../store/actions";

const BackendUsers: React.FC = (): ReactElement => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openAddRoleModal, setOpenAddRoleModal] = useState<boolean>(false);
  const queryParams = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState<string>(
    queryParams.get("tab") || "1"
  );

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Backend users",
            type: "link",
            link: "/backend-users",
          },
        ],
      },
    });
  }, []);

  const getItems = () => {
    const items: any = [];

    if (user?.permissions.includes("backend_users")) {
      items.push({
        key: "1",
        label: `Users`,
        children: <UsersList />,
      });
    }

    if (user?.permissions.includes("backend_roles")) {
      items.push({
        key: "2",
        label: `Roles`,
        children: <RolesList />,
      });
    }

    return items;
  };

  const options: SelectProps["options"] = [
    // {
    //   value: "Send reset password link",
    //   label: (
    //     <div className="select-options flex align-center">
    //       <img src={KeyImage} /> <span>Send reset password link</span>
    //     </div>
    //   ),
    // },
    // {
    //   value: "Add manual password",
    //   label: (
    //     <div className="select-options flex align-center">
    //       <img src={ShieldImage} /> <span>Add manual password</span>
    //     </div>
    //   ),
    // },
    {
      value: "Create New",
      label:
        activeTab === "1" ? (
          user?.permissions.includes("backend_users") && (
            <div
              className="select-options flex align-center"
              onClick={() => setOpenAddModal(true)}
            >
              <img src={ShieldImage} /> <span>Create new user</span>
            </div>
          )
        ) : (
          <div
            className="select-options flex align-center"
            onClick={() => setOpenAddRoleModal(true)}
          >
            <img src={ShieldImage} /> <span>Create new role</span>
          </div>
        ),
    },
  ];

  const onTabChange = (activeKey: string): void => {
    setActiveTab(activeKey);
  };

  return (
    <div className="backend-users-container flex column">
      <div className="flex align-center justify-space-between wrap">
        <BreadcrumbComponent />
        <Select
          allowClear
          showSearch
          value={null}
          options={options}
          placeholder={
            <div className="flex">
              <SearchOutlined
                style={{
                  marginInlineEnd: "5px",
                }}
              />{" "}
              Search
            </div>
          }
        />
      </div>
      <TabsComponent
        items={getItems()}
        activeTab={activeTab}
        onChange={onTabChange}
      />
      <CustomModal
        isVisible={openAddModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenAddModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex column align-center justify-center">
          <AddEditUser
            onCancel={() => {
              setOpenAddModal(false);
            }}
            onConfirm={() => {
              setOpenAddModal(false);
            }}
          />
        </div>
      </CustomModal>

      <CustomModal
        isVisible={openAddRoleModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenAddRoleModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex column align-center justify-center">
          <AddEditRole
            onCancel={() => {
              setOpenAddRoleModal(false);
            }}
            onConfirm={() => {
              window.location.reload();
            }}
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default BackendUsers;
